export default "__VITE_ASSET__B8me8DEv__"